import React, { useState, useEffect } from "react";
import { Layout, Input } from "antd";

import { SearchOutlined } from "@ant-design/icons";
import Text from "antd/lib/typography/Text";
import { Header } from "antd/lib/layout/layout";
import { useDispatch, useSelector } from "react-redux";
import { Draggable, Droppable } from "react-beautiful-dnd";
import styled from "styled-components";

import toggleArrow from "../../../assets/createWidget/toggle_arrow.svg";
import toggleArrowWhite from "../../../assets/WhiteIcons/toggle_arrow_white.svg";

import GoogleplaystoreAttributes from "../../../assets/createWidget/attributes/GoogleplaystoreAttributes.svg";
import TaggingCategory from "../../../assets/createWidget/attributes/TaggingCategory.svg";
import YouTubeAttribute from "../../../assets/createWidget/attributes/YouTubeAttribute.svg";
import AuthorCharacteristics from "../../../assets/createWidget/attributes/AuthorCharacteristics.svg";
import AuthorMetrics from "../../../assets/createWidget/attributes/AuthorMetrics.svg";

import GMBAttribute from "../../../assets/createWidget/attributes/GMBAttribute.svg";
import TypeofPost from "../../../assets/createWidget/attributes/TypeofPost.svg";
import InstagramAttribute from "../../../assets/createWidget/attributes/InstagramAttribute.svg";
import TwitterAttribute from "../../../assets/createWidget/attributes/TwitterAttribute.svg";
import AITagged from "../../../assets/createWidget/attributes/AITagged.svg";
import customattribute from "../../../assets/createWidget/attributes/customattribute.svg";
import accoArrow from "../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import FacebookAttribute from "../../../assets/createWidget/attributes/FacebookAttribute.svg";
import engagement from "../../../assets/createWidget/attributes/engagement.svg";
import entities from "../../../assets/createWidget/attributes/entities.svg";
import source from "../../../assets/createWidget/attributes/source.svg";
import tagging from "../../../assets/createWidget/attributes/tagging.svg";
import tickets from "../../../assets/createWidget/attributes/tickets.svg";
import timing from "../../../assets/createWidget/attributes/timing.svg";
import QuoraAttributes from "../../../assets/createWidget/attributes/Quora_Icon.svg";
import {
  setIsshowSideBar,
  setAttrAccordionObject,
} from "../../../redux/actions/WidgetMaker/WidgetMaker";
import CustomAttributeModal from "./customAttribute/CustomAttributeModal";
import noSearchResult from "../../../assets/No_Result_Found.svg";
import search_icon from "../../../assets/search_icon.svg";
import searchWhite_icon from "../../../assets/WhiteIcons/searchWhite_icon.svg";
import Drag_Icon from "../../../assets/Template/Drag_Icon.svg";
import { setCustomAttributeName } from "../../../redux/actions/WidgetMaker/GraphConfig";

const ContainerMain = styled.div`
  &:hover {
    background-image: url(${Drag_Icon});
  }
`;
const getItemStyle = (isDragging, draggableStyle) => {
  // console.log("isDragging : ", isDragging, "draggableStyle : ", draggableStyle);
  return {
    // some basic styles to make the items look a bit nicer
    // styles we need to apply on draggable
    ...draggableStyle,
    height: isDragging ? 30 : "auto", // Ensures height remains valid
    padding: isDragging ? "0.5rem" : "1rem 1rem 1rem 2rem", // Keeps consistent padding
    // background: isDragging ? "lightblue" : "white",
    cursor: "grab",
    transform: draggableStyle?.transform || "translate(0px, 0px)", // Prevents null transform
    opacity: draggableStyle?.opacity ?? 1, // Ensures opacity is always defined
  };
};
const getAttributeIcon = (id) => {
  switch (id) {
    case "Author Characteristics":
      return AuthorCharacteristics;
    case "Source Of Post":
      return source;
    case "Timing":
      return timing;
    case "Derived Entities":
      return entities;
    case "AI Tagged":
      return AITagged;
    case "Tagging Category":
      return TaggingCategory;
    case "Enagagement":
      return engagement;
    case "GMB Attributes":
      return GMBAttribute;
    case "YouTube Attributes":
      return YouTubeAttribute;
    case "Google Play Store Attributes":
      return GoogleplaystoreAttributes;
    case "Type of Post":
      return TypeofPost;
    case "Instagram Attributes":
      return InstagramAttribute;
    case "Twitter Attributes":
      return TwitterAttribute;
    case "Facebook Attributes":
      return FacebookAttribute;
    case "others":
      return customattribute;
    case "Author Metrics":
      return AuthorMetrics;
    case "Quora Attributes":
      return QuoraAttributes;
    default:
      return tickets;
  }
};

const AttributeList = ({ list, index, others }) => {
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  return (
    <Draggable
      draggableId={`${list}#${others.datatype}`}
      key={`${list}#${others.datatype}`}
      index={index}
    >
      {(provided, snapshot) => (
        <ContainerMain
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className="draggable_ContainerMain"
          style={getItemStyle(
            snapshot.isDragging,
            provided.draggableProps.style
          )}
        >
          {/* {console.log("Draggable ID: ", `${list}#${others.datatype}`)}
          {console.log(
            "list : ",
            list,
            "widgetGraphConfig?.dragDataType?.attribute : ",
            widgetGraphConfig?.dragDataType?.attribute,
            "others : ",
            others,
            "index : ",
            index
          )} */}
          <div className="draggable_Container">{All_WM_attributes[list]}</div>
          {others?.description !== "NULL" && others?.description ? (
            <div
              style={
                {
                  // display:
                  //   widgetGraphConfig?.dragDataType?.attribute === list &&
                  //   (widgetGraphConfig?.dragDataType?.varchar ||
                  //     widgetGraphConfig?.dragDataType?.int ||
                  //     widgetGraphConfig?.dragDataType?.json ||
                  //     widgetGraphConfig?.dragDataType?.datetime)
                  //     ? "none"
                  //     : "",
                }
              }
              className={`draggable_Description ${
                widgetGraphConfig?.dragDataType?.attribute === list &&
                (widgetGraphConfig?.dragDataType?.varchar ||
                  widgetGraphConfig?.dragDataType?.int ||
                  widgetGraphConfig?.dragDataType?.json ||
                  widgetGraphConfig?.dragDataType?.datetime)
                  ? "onAttributeDragging"
                  : ""
              }`}
            >
              {others?.description}
            </div>
          ) : (
            ""
          )}
        </ContainerMain>
      )}
    </Draggable>
  );
};

const AttributePanel = ({ setShowChartSide, firstPage }) => {
  const { Content } = Layout;
  const dispatch = useDispatch();
  const WM_attributes = useSelector((state) => state.WidgetMaker.WM_attributes);
  const [allAttributes, setAllAttributes] = useState(WM_attributes);
  const [customAttributeVisible, setCustomAttributeVisible] = useState(false);
  const [visible, setVisible] = useState(false);
  const [accordion, setAccordion] = useState(null);
  const [flag, setflag] = useState(false);
  const [attributeName, setAttributeName] = useState("");
  const [description, setdescription] = useState(null);
  const chartLoader = useSelector((state) => state?.WidgetAPI?.chart_loader);
  const isshowSideBar = useSelector((state) => state.WidgetMaker.isshowSideBar);
  const authParams = useSelector((state) => state.Authentication.authParams);

  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const attrAccordionObject = useSelector(
    (state) => state?.WidgetMaker?.attrAccordionObject
  );

  // const inputRef = useRef(null);
  const suffix = (
    <img
      src={authParams?.theme_type === "1" ? searchWhite_icon : search_icon}
      alt="search icon"
      style={{ maxWidth: "2.5rem" }}
    />
  );
  useEffect(() => {
    setShowChartSide(isshowSideBar);
  }, [isshowSideBar]);

  useEffect(() => {
    if (!flag && widgetGraphConfig?.custom_attribute?.name) {
      // if (inputRef) {
      //   setAttributeName(widgetGraphConfig?.custom_attribute?.name);
      // }
    } else {
      setAttributeName("");
    }
  }, [widgetGraphConfig]);

  const handleSearch = (e) => {
    let searchData = {};
    WM_attributes.forEach((el) =>
      el[1].forEach((g) => {
        let data = searchData[el[0]]?.length > 0 ? searchData[el[0]] : [];
        if (g[1]?.title.toLowerCase().includes(e.target.value.toLowerCase())) {
          searchData = {
            ...searchData,
            [el[0]]: [...data, g],
          };
        }
      })
    );
    let finalData = Object.entries(searchData);
    setAllAttributes(finalData);
  };

  const openCustomAttributeModal = () => {
    setCustomAttributeVisible(true);
    setVisible(false);
    setflag(false);
    dispatch(setCustomAttributeName(attributeName, widgetGraphConfig));
  };

  const handleSaveWidget = () => {};

  const handleBackButton = () => {};

  const handleChangeAttribute = (e) => {
    setflag(true);
    setAttributeName(e.target.value);
  };

  const handleDescriptionAttribute = (e) => {
    setdescription(e.target.value);
  };
  useEffect(() => {
    if (attrAccordionObject?.length === 0) {
      const listof = allAttributes?.map((el, i) => {
        return { id: i, value: false };
      });
      listof && dispatch(setAttrAccordionObject(listof));
      setAllAttributes(WM_attributes);
    }
  }, [allAttributes, WM_attributes]);

  const handleAccordion = (id) => {
    let listofObject = attrAccordionObject;
    listofObject &&
      listofObject?.forEach((el) => {
        if (el?.id === id) {
          el.value = !el?.value;
        }
      });
    dispatch(setAttrAccordionObject(listofObject));
  };
  return (
    <Layout className={`bg__white ${chartLoader && "disable"}`}>
      <Header className="bg__white h-auto p-15 line-height-normal">
        <div className="d-flex justify-content-between mb-2 align-items-center">
          <Text
            className={`text_heading font-weight600 ${
              isshowSideBar ? "d-none" : ""
            }`}
          >
            Attributes
          </Text>

          {/* <div className={`text_heading font-weight500 ${
              isshowSideBar ? "d-none" : ""
            }`}>
            <Popover
              placement="bottomRight"
              content={
                <Box
                  component="form"
                  sx={{
                    "& .MuiTextField-root": { margin: "0.8rem 0", width: "40ch" },
                  }}
                  style={{
                    position: "absolute",
                    right: "-20rem",
                    borderRadius: "0.8rem",
                    boxShadow: "0rem 0.3rem 0.6rem #00000029",
                  }}
                  noValidate
                  autoComplete="off"
                  className="position-absolute bg-white p-15 box-shadow bg-white "
                >
                  <div className="d-flex justify-content-between">
                    <div className=" w-100">
                      <div className="position-relative">
                        <TextField
                          required
                          rows={2}
                          id="outlined-required"
                          inputRef={inputRef}
                          label="Attribute Name"
                          fullWidth={true}
                          size="small"
                          style={{
                            borderRadius: "0.8rem",
                            borderColor: "#C3CBD7",
                          }}
                          inputProps={{ maxLength: 30 }}
                          InputLabelProps={{
                            shrink:
                              attributeName && attributeName?.trim().length > 0
                                ? true
                                : false,
                          }}
                          value={attributeName}
                          error={flag && attributeName?.trim()?.length === 0}
                          helperText={
                            flag &&
                            attributeName?.trim()?.length === 0 && (
                              <span className="error">
                                Attribute name can not be empty *
                              </span>
                            )
                          }
                          onChange={(e) => handleChangeAttribute(e)}
                          sx={{
                            "& .MuiInputLabel-root": {
                              color: "#7A89A0",
                              fontSize: "1.4rem",
                            },
                            "& .MuiInputLabel-root .MuiInputLabel-asterisk": {
                              color: "#d32f2f",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": { borderColor: "#C3CBD7" },
                              "&:hover fieldset": {
                                borderColor: "#C3CBD7",
                              },
                            },
                            "& .MuiInputBase-input": {
                              color: "#3B5175",
                              fontSize: "1.4rem",
                              minHeight: "2.5rem",
                              fontFamily: '"Roboto", sans-serif',
                            },
                          }}
                        />
                        <span
                          className="text-gray position-absolute font-size14"
                          style={{
                            right: "0.3rem",
                            bottom: "0.6rem",
                          }}
                        >
                          {attributeName?.length > 0
                            ? attributeName?.length
                            : "0"}
                          /30
                        </span>
                      </div>
                      <div className="position-relative">
                        <TextField
                          rows={3}
                          id="outlined-required"
                          label="Enter Description"
                          multiline
                          fullWidth={true}
                          size="small"
                          style={{
                            borderRadius: "0.8rem",
                            borderColor: "#C3CBD7",
                          }}
                          inputProps={{ maxLength: 150 }}
                          value={description}
                          onChange={(e) => handleDescriptionAttribute(e)}
                          sx={{
                            "& .MuiInputLabel-root": {
                              color: "#7A89A0",
                              fontSize: "1.4rem",
                            },
                            "& .MuiInputLabel-root .MuiInputLabel-asterisk": {
                              color: "#d32f2f",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": { borderColor: "#C3CBD7" },
                              "&:hover fieldset": {
                                borderColor: "#C3CBD7",
                              },
                            },
                            "& .MuiInputBase-input": {
                              color: "#3B5175",
                              fontSize: "1.4rem",
                              minHeight: "2.5rem",
                              fontFamily: '"Roboto", sans-serif',
                              marginBottom: "1rem",
                            },
                            "& .MuiInputBase-input::-webkit-scrollbar-track": {
                              backgroundColor: "white",
                            },
                            "& .MuiInputBase-input::-webkit-scrollbar": {
                              width: " 0.8rem",
                              backgroundColor: "white",
                            },
                            "& .MuiInputBase-input::-webkit-scrollbar-thumb": {
                              borderRadius: " 0.4rem",
                              backgroundColor: "#e8eaee",
                            },
                          }}
                        />
                        <span
                          className="text-gray position-absolute font-size14"
                          style={{
                            right: "0.3rem",
                            bottom: "0.6rem",
                          }}
                        >
                          {description?.length > 0 ? description?.length : "0"}
                          /150
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <Button
                      type="button"
                      className="btn_Clear mr-15"
                      onClick={() => {
                        setVisible(false);
                        setflag(false);
                        setAttributeName("");
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      className="ant-btn-primary_blue"
                      style={{
                        pointerEvents:
                          attributeName === null
                            ? "none"
                            : attributeName?.trim().length === 0
                            ? "none"
                            : "auto",
                        opacity:
                          attributeName === null
                            ? "0.5"
                            : attributeName?.trim().length === 0
                            ? "0.5"
                            : "1",
                      }}
                      onClick={() => openCustomAttributeModal()}
                    >
                      Add Attribute
                    </Button>
                  </div>
                </Box>
              }
              title={null}
              trigger="click"
              visible={visible}
            >
              <Text
                className="text_heading"
                style={{ color: "#1890ff" }}
                onClick={() => {
                  setVisible(true);
                }}
              >
                + Create New
              </Text>
            </Popover>
          </div> */}
          <Text
            className="text_heading font-weight600 cursor-pointer"
            onClick={() => dispatch(setIsshowSideBar(!isshowSideBar))}
          >
            <img
              src={
                authParams?.theme_type === "1" ? toggleArrowWhite : toggleArrow
              }
              alt="toggleArrow"
              style={{
                transform: isshowSideBar ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
          </Text>
        </div>
        <div
          className={`${
            isshowSideBar ? "d-none" : "d-flex"
          } justify-content-between align-items-center`}
        >
          <Input
            className="border-radius-4 border-color"
            placeholder="Search attributes"
            suffix={suffix}
            style={{ height: "4rem" }}
            onChange={handleSearch}
          />
          {/* <Text className="text_heading font-weight600 ml-1 d-none">a</Text> */}
        </div>
      </Header>
      <Content
        className={`custom_scroll1 pl-15 mr-1 ${isshowSideBar ? "d-none" : ""}`}
        style={{
          height: firstPage ? "calc(100vh - 19.6rem)" : "calc(100vh - 15rem)",
          overflow: "auto",
        }}
      >
        {allAttributes && attrAccordionObject && allAttributes?.length > 0 ? (
          <>
            {allAttributes?.map((e, i) => {
              return (
                <Droppable droppableId={`${e[0]}#member`}>
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      <div
                        style={{
                          paddingBottom:
                            attrAccordionObject[i]?.id === i &&
                            attrAccordionObject[i]?.value
                              ? "1rem"
                              : "",
                        }}
                        className="font-weight600 d-flex justify-content-between align-items-center text_heading text-transform__capitalize"
                      >
                        <span>
                          <img
                            src={getAttributeIcon(e[0])}
                            alt="img"
                            className="mr-1"
                            style={{ maxWidth: "1.6rem" }}
                          />
                          {e[0]}
                        </span>
                        <img
                          src={
                            authParams?.theme_type === "1"
                              ? accoArrowWhite
                              : accoArrow
                          }
                          alt="arrow"
                          className="accordionArrow mr-1 cursor-pointer"
                          onClick={() => handleAccordion(i)}
                          style={{
                            transform: `rotate(${
                              attrAccordionObject[i]?.id === i &&
                              attrAccordionObject[i]?.value
                                ? "0deg"
                                : "180deg"
                            })`,
                            maxWidth: "100%",
                          }}
                        />
                      </div>
                      <div
                        className={
                          attrAccordionObject[i]?.id === i &&
                          attrAccordionObject[i]?.value
                            ? "d-none"
                            : ""
                        }
                      >
                        {e[1]?.map(
                          (el, i) =>
                            el[1]?.datatype !== "spatial" &&
                            el[1]?.plottable && (
                              <AttributeList
                                list={el[0]}
                                others={el[1]}
                                index={i}
                              />
                            )
                        )}
                      </div>
                    </div>
                  )}
                </Droppable>
              );
            })}
          </>
        ) : (
          <div className="w-100 text-center">
            <div className="Nodata_img mb-15">
              <img src={noSearchResult} alt="no data" />
            </div>
            <div className="text_regular-gray">No Attribute Found</div>
          </div>
        )}

        {customAttributeVisible && (
          <CustomAttributeModal
            visible={customAttributeVisible}
            setVisible={setCustomAttributeVisible}
          />
        )}
      </Content>
    </Layout>
  );
};

export default AttributePanel;
